import { ActivityFactory, ItineraryActivity } from "./activity.model";
import { templateDayKey } from "./day-axis";

/**
 * Ciò che serve per mostrare un giorno, comune al DTO di persistenza (`ItineraryDay`)
 * e allo stato di editing del builder (`ItineraryDayBuilder`): la UI tipizza su questo
 * e non deve annusare le proprietà per capire quale dei due ha in mano.
 */
export interface DayView {
    /** Data ISO sugli itinerari collegati, `D<n>` sui template (vedi `day-axis.ts`). */
    key: string;
    /** Data reale del giorno, null sui template. */
    date: string | null;
    /** Posizione 1-based del giorno nell'itinerario. */
    index: number;
    activities: ItineraryActivity[] | Partial<ItineraryActivity>[];
    /** Il giorno esce dalla finestra della travel request collegata (solo nel builder). */
    exceedsTravelRequest?: boolean;
}

/**
 * Un giorno dell'itinerario come viene persistito: `date` valorizzata sugli itinerari
 * collegati a una travel request, `day_index` sui template.
 */
export interface IItineraryDay {
    key?: string;
    date?: string | null;
    day_index?: number | null;
    activities: ItineraryActivity[] | Partial<ItineraryActivity>[];
}

export class ItineraryDay implements IItineraryDay, DayView {
    key: string;
    date: string | null;
    day_index: number | null;
    activities: ItineraryActivity[] | Partial<ItineraryActivity>[];

    /** DayView parla di posizione, la persistenza di `day_index`: stesso numero. */
    get index(): number {
        return this.day_index ?? 1;
    }

    constructor(data?: IItineraryDay) {
        this.date = data?.date || null;
        this.day_index = data?.day_index ?? null;
        // I dati legacy hanno solo `date`: lì la chiave è la data stessa.
        this.key = data?.key || this.date || (this.day_index ? templateDayKey(this.day_index) : '');
        this.activities = data?.activities.sort((a,b) => a.location < b.location ? -1 : 1).map(activity => ActivityFactory.create(activity)) || [];
    }
}
